// extracted by mini-css-extract-plugin
module.exports = {"ctaCard":"CTACard-module--ctaCard--2S3QI","ctaBody":"CTACard-module--ctaBody--2q3OO","link":"CTACard-module--link--2XYVv"};